import moment from "moment";

export function convertToJSDate(neo4jDate) {
    const dateDetails = [];
    const keys = Object.keys(neo4jDate);
    for (let key of keys) {
        if (key === "month") {
            dateDetails.push(neo4jDate[key].low - 1);
        } else if (key !== "timeZoneId") {
            dateDetails.push(neo4jDate[key].low);
        }
    }
    dateDetails.pop();
    dateDetails.pop();
    return dateDetails;
}

export function getMomentDifference(time, format) {
    let difference
    var currentTime = moment()
    var EarlierTime = moment(time)
    difference = currentTime.diff(EarlierTime, format)
    return difference
}

export function CheckForInternalUser(username) {
    let internalUser = false
    internalUser = process.env.REACT_APP_WHITELIST.split(" ").includes(username);
    return internalUser;
}

export function isNullOrUndefined(value) {
    return value === null || value === undefined;
}

export function hasSpecialCharacters(value) {
    return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value);
}

export function CheckForAdminAccess(username) {
    let adminAccess = false
    adminAccess = process.env.REACT_APP_ADMINLIST.split(" ").includes(username);
    return adminAccess;
}

export function getJSDate(neo4jDate) {
    const date = new Date();
    for (const key in neo4jDate) {
        switch (key) {
            case "year":
                date.setUTCFullYear(neo4jDate[key].low)
                break;
            case "month":
                date.setUTCMonth(neo4jDate[key].low - 1)
                break;
            case "day":
                date.setUTCDate(neo4jDate[key].low)
                break;
            case "hour":
                date.setUTCHours(neo4jDate[key].low)
                break;
            case "minute":
                date.setUTCMinutes(neo4jDate[key].low)
                break;
            case "second":
                date.setUTCSeconds(neo4jDate[key].low)
                break;
            default:
                break;
        }
    }
    return date;
}

export async function copyToClipboard(text) {
    if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
    }
    else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        }
        catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        }
        finally {
            document.body.removeChild(textarea);
        }
    }
}